import { forwardRef } from "react";
import {
  Link as RouterLink,
  NavLink as RouterNavLink,
  Navigate as RouterNavigate,
  type LinkProps,
  type NavLinkProps,
  type NavigateProps,
} from "react-router-dom";
import { useLocalizePath } from "@/hooks/useLocalizedPath";

// Drop in replacements for react-router's Link, NavLink and Navigate that keep
// public pages in the active language (see useLocalizePath).

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ to, ...props }, ref) => {
    const localize = useLocalizePath();
    return <RouterLink ref={ref} to={localize(to)} {...props} />;
  },
);
Link.displayName = "LocalizedLink";

export const NavLink = forwardRef<HTMLAnchorElement, NavLinkProps>(
  ({ to, ...props }, ref) => {
    const localize = useLocalizePath();
    return <RouterNavLink ref={ref} to={localize(to)} {...props} />;
  },
);
NavLink.displayName = "LocalizedNavLink";

export function Navigate({ to, ...props }: NavigateProps) {
  const localize = useLocalizePath();
  return <RouterNavigate to={localize(to)} {...props} />;
}
